import { useEffect } from 'react';

import currentVersion from '../../assets/version.json';

import { useNotifications } from './useNotifications';

const POLL_INTERVAL_MS = 10 * 60 * 1000;
const VERSION_URL = '/assets/version.json';

export const useVersionCheck = () => {
  const notifications = useNotifications();

  const check = async () => {
    try {
      const res = await fetch(`${VERSION_URL}?t=${Date.now()}`, {
        cache: 'no-store',
      });
      if (!res.ok) {
        return;
      }
      const data: { commit?: string } = await res.json();
      if (data.commit && data.commit !== currentVersion.commit) {
        notifications.conflict(
          'Dostępna jest nowa wersja aplikacji. Odśwież stronę (F5).',
        );
      }
    } catch {
      // ignore network errors silently
    }
  };

  useEffect(() => {
    void check();
    const interval = setInterval(() => void check(), POLL_INTERVAL_MS);

    const onVisible = () => {
      if (document.visibilityState === 'visible') {
        void check();
      }
    };
    document.addEventListener('visibilitychange', onVisible);

    return () => {
      clearInterval(interval);
      document.removeEventListener('visibilitychange', onVisible);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
